import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import "./Layout.css";

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout">
      {/* Sidebar (Toggles on Mobile) */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      
      <div className="main-content">
        {/* Header (Has Sidebar Toggle Button on Mobile) */}
        <Header setSidebarOpen={setSidebarOpen} />
        
        {/* Page Content */}
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
